import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["items", "hasNextPage", "isLoading", "getFormsList", "openDetail", "editForm", "deleteForm", "height"];
import React, { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import FormsListItem from "../FormsListItem";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FormsList');
function FormsList(_ref) {
  let {
      items,
      hasNextPage,
      isLoading,
      getFormsList,
      openDetail,
      editForm,
      deleteForm,
      height
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const itemCount = useMemo(() => {
    return hasNextPage ? items.length + 1 : items.length;
  }, [items.length, hasNextPage]);
  const loadMoreItems = useMemo(() => {
    return isLoading ? () => {} : getFormsList;
  }, [getFormsList, isLoading]);
  const isItemLoaded = useCallback(index => {
    return !hasNextPage || index < items.length;
  }, [items.length, hasNextPage]);
  const Row = useCallback(_ref2 => {
    let {
      index,
      style
    } = _ref2;
    const item = items[index];
    if (!item || !item.list) return null;
    return /*#__PURE__*/React.createElement(FormsListItem, {
      id: item.id,
      idFormType: item.formTemplateId,
      pos11: item.list.pos11,
      pos12: item.list.pos12,
      pos13: item.list.pos13,
      pos21: item.list.pos21,
      pos22: item.list.pos22,
      pos23: item.list.pos23,
      readOnly: item.endState,
      openDetail: openDetail,
      editForm: editForm,
      deleteForm: deleteForm,
      style: style
    });
  }, [items, openDetail, editForm, deleteForm]);
  if (!items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(InfiniteLoader, {
    isItemLoaded: isItemLoaded,
    itemCount: itemCount,
    loadMoreItems: loadMoreItems
  }, _ref3 => {
    let {
      onItemsRendered,
      ref
    } = _ref3;
    return /*#__PURE__*/React.createElement(List, {
      className: classes.list,
      height: height,
      itemCount: itemCount,
      itemSize: 96,
      onItemsRendered: onItemsRendered,
      ref: ref
    }, Row);
  }));
}
process.env.NODE_ENV !== "production" ? FormsList.propTypes = {
  items: PropTypes.array,
  hasNextPage: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  getFormsList: PropTypes.func.isRequired,
  openDetail: PropTypes.func.isRequired,
  editForm: PropTypes.func.isRequired,
  deleteForm: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired
} : void 0;
export default /*#__PURE__*/memo(FormsList);